import * as React from 'react';
import { Body2, UIHeading4, Image } from '@cian/ui-kit';

import * as style from './style.css';
import aberMobile from '../assets/AberMobile.svg';

export interface IAiBannerMobileProps {
  title: string;
  subtitle: string;
  onOpen: () => void;
}

export const AiBannerMobile = ({ title, subtitle, onOpen }: IAiBannerMobileProps): React.JSX.Element => {
  return (
    <div className={style['container']} data-testid="ai-banner" onClick={onOpen}>
      <div className={style['text-wrapper']}>
        <UIHeading4>{title}</UIHeading4>
        <Body2 color="text-secondary-default">{subtitle}</Body2>
      </div>
      <Image src={aberMobile} height={40} width={54} preloader={false} />
    </div>
  );
};
